export const setAuth = auth => ({
  type: "SET_AUTH",
  auth
});

export const setExpiresIn = expiresIn => ({
  type: "SET_EXPIRES_IN",
  expiresIn
});

export const setTokenCreatedAt = createdAt => ({
  type: "SET_TOKEN_CREATED_AT",
  createdAt
});

export const setAuthUser = user => ({
  type: "SET_AUTH_USER",
  user
});

export const fetchAuthUser = user => ({
  type: "FETCH_AUTH_USER",
  payload: user
});

export const setAuthToken = token => ({
  type: "SET_AUTH_TOKEN",
  token
});

export const setAuthLoggedAs = loggedAs => ({
  type: "SET_AUTH_LOGGED_AS",
  loggedAs
});

export const setAuthLoggedAsPost = loggedAsPost => ({
  type: "SET_AUTH_LOGGED_AS_POST",
  loggedAsPost
});

export const setNavCommunity = community => ({
  type: "SET_NAV_COMMUNITY",
  community
});



// WEBPACK FOOTER //
// ./src/actions/actions/auth.js